import React from 'react'
import GetLocation from '../../components/Host/GetLocation'

function Location() {
  return (
        <GetLocation />
  )
}

export default Location